import React from 'react';
import { CTAButton } from './CTAButton';
import { PriceBlock } from './PriceBlock';
import { TrustStrip } from './TrustStrip';
import { HERO_STATS } from './salesData';
import { HERO_IMAGE_URL } from '../utils/headMeta';

/**
 * Hero de KETO 4P. El mockup oficial es el protagonista visual y el elemento
 * LCP: se muestra completo, sin recortes ni textos encima.
 */
export function Hero() {
  return <section className="warm-halo relative w-full overflow-hidden border-b border-line" data-id="element-115" data-mp="12a0it4iflorg">
      <div className="mx-auto grid max-w-6xl gap-5 px-5 pb-10 pt-6 sm:gap-10 sm:px-8 sm:pb-20 sm:pt-14 lg:grid-cols-[1.05fr_0.95fr] lg:items-center lg:gap-14 lg:pb-24 lg:pt-20" data-id="element-116" data-mp="x9upzl0fdw7s">
        {/* Copy */}
        <div className="animate-hero-copy order-2 lg:order-1" data-id="element-117" data-mp="ncq1hej3xont">
          <p className="font-display text-[0.68rem] uppercase tracking-editorial text-gold" data-id="element-118" data-mp="neav91xll3km">
            Keto 4P · Panes · Pizzas · Pastas · Postres
          </p>

          <h1 className="mt-3 font-condensed text-[1.95rem] uppercase leading-[0.92] text-bone sm:mt-4 sm:text-6xl lg:text-[4.15rem]" data-id="element-119" data-mp="381nu37c3sp2w">
            500 recetas keto para comer{' '}
            <span className="text-glow-gold" data-id="element-120" data-mp="3o7vjnj38jlwr">rico, variado y sin culpa</span>
          </h1>

          <p className="mt-3 max-w-xl text-[0.92rem] leading-relaxed text-ash sm:mt-5 sm:text-lg" data-id="element-121" data-mp="39aur5dd7zmx8">
            Panes, pizzas, pastas y postres keto para que mantenerte en cetosis deje de significar
            comer siempre lo mismo.
          </p>

          {/* 6 TOMOS · 500 RECETAS · 5 BONOS */}
          <dl className="mt-5 grid grid-cols-3 overflow-hidden rounded-xl border border-gold/25 bg-gold/[0.06] sm:mt-7" data-id="element-122" data-mp="3599ki9ra44vh">
            {HERO_STATS.map((stat, index) => <div key={stat.etiqueta} className={`px-2 py-2.5 text-center sm:px-3 sm:py-4 ${index > 0 ? 'border-l border-gold/20' : ''}`} data-id="element-123" data-mp="2qi0o9hsvfl9d" data-mpi={index}>
                <dt className="font-condensed text-2xl leading-none text-gold sm:text-4xl" data-id="element-124" data-mp="2hl9r122l20d7">
                  {stat.valor}
                </dt>
                <dd className="mt-1 font-display text-[0.5rem] uppercase leading-tight tracking-editorial text-bone/75 sm:mt-1.5 sm:text-[0.55rem]" data-id="element-125" data-mp="s2b89zesml5o">
                  {stat.etiqueta}
                </dd>
              </div>)}
          </dl>

          <div className="mt-5 flex flex-col gap-3 sm:mt-7 sm:flex-row sm:items-center sm:gap-4" data-id="element-126" data-mp="ia5jsznr2lv8">
            <CTAButton data-id="element-127" data-mp="db2dzczy4bm7" />
            <PriceBlock size="sm" layout="inline" data-id="element-128" data-mp="1b0njrrt6g74f" />
          </div>

          <p className="mt-3 text-[0.78rem] text-ash" data-id="element-129" data-mp="1ayt9d7fj7xel">
            Acceso digital · Pago único · Lo abrís en el celular
          </p>

          <TrustStrip className="mt-6 border-t border-line pt-5 sm:mt-7 sm:pt-6" data-id="element-130" data-mp="112g5jgq9w364" />
        </div>

        {/* Mockup oficial */}
        <div className="animate-hero-media order-1 lg:order-2" data-id="element-131" data-mp="x031qxv36fbz">
          <img src={HERO_IMAGE_URL} alt="KETO 4P: los 6 tomos digitales con 500 recetas de panes, pizzas, pastas y postres, más los 5 bonos exclusivos" width={1087} height={1449} fetchPriority="high" decoding="async" className="mx-auto w-full max-w-[190px] rounded-xl shadow-[0_40px_120px_-45px_rgba(255,196,0,0.45)] sm:max-w-[520px]" data-id="element-132" data-mp="3lsp1x9cpsbcb" />
        </div>
      </div>
    </section>;
}